export function addWhiteLabelConfig(whitelabelconfig) {
  return {
    type: 'ADD_CURRENT_WHITE_LABEL_CONFIG',
    whitelabelconfig,
  }
}